import React, { useState, useEffect } from 'react'
import {
  Button,
  BoxContainer,
  Table
} from '../../../../../../../components/index'
import HeaderItem from '../../../../../../../components/Table/HeaderItem'
import RowItem from '../../../../../../../components/Table/RowItem'
import useUrlParam from '../../../../../../../hooks/useUrlParam'
import ecbrApi from '../../../../../../../services/ecbrApi'
import { useInfinitePagination } from '../../../../../../../hooks/useInfinitePagination'
import { PaginationOrder } from '../../../../../../../constants/pagination'
import {
  InvoiceStatus,
  InvoiceStatusColors
} from '../../../../../../../constants/invoice'
import { PaymentMethodTextForList } from '../../../../../../../constants/order'
import StatusBadge from '../../../../../../../components/StatusBadge'
import { dateTypes } from '../../../../../../../constants/date'
import { formatCentsToReal } from '../../../../../../../helpers/formatCentsToReal'
import dayjs from '../../../../../../../helpers/dayjs'

const pagination = { page: 1, take: 10 }

const PaymentTable = () => {
  const [error, setError] = useState('')
  const [companyId, brandId] = useUrlParam('/admin/companies/:id/brands/:id')
  const [searchParameters, _setSearchParameters] = useState({
    ...pagination,
    order: PaginationOrder.ASC,
    companyId: companyId || null,
    brandId: brandId || null,
    status: InvoiceStatus.PAID
  })

  const {
    data: invoices,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading,
    refetch
  } = useInfinitePagination(
    'invoices',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.invoices.getAll({
        ...searchParameters,
        page: pageParam || searchParameters.page
      })
    },
    {
      enabled:
        searchParameters.companyId !== null &&
        searchParameters.brandId !== null,
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParameters])

  const getPaymentMethodText = (paymentMethodId) => {
    return PaymentMethodTextForList[paymentMethodId] || 'Não definido'
  }

  const getInvoiceStatusText = (status) => {
    const statusText = {
      [InvoiceStatus.PAID]: 'Pago',
      [InvoiceStatus.PENDING]: 'Pendente',
      [InvoiceStatus.CANCELED]: 'Cancelado',
      [InvoiceStatus.FAILED]: 'Falhou',
      [InvoiceStatus.PROCESSING]: 'Processando',
      [InvoiceStatus.OVERPAID]: 'Sobrepago',
      [InvoiceStatus.UNDERPAID]: 'Descontado'
    }
    return statusText[status] || 'Não definido'
  }

  return (
    <BoxContainer>
      {error && <p>{error}</p>}
      {!error && (
        <Table templateColumns="10% 22% 13% 16% 8% 12% 14%">
          <header>
            <ul>
              <HeaderItem>Identificação</HeaderItem>
              <HeaderItem>Certificação</HeaderItem>
              <HeaderItem>Valor</HeaderItem>
              <HeaderItem>Tipo</HeaderItem>
              <HeaderItem>Parcelas</HeaderItem>
              <HeaderItem>Data</HeaderItem>
              <HeaderItem>Status</HeaderItem>
            </ul>
          </header>
          <main>
            {invoices?.map?.((invoice) => (
              <ul key={invoice.id}>
                <RowItem>{`#${invoice.id}`}</RowItem>
                <RowItem>{invoice.products?.[0]?.name}</RowItem>
                <RowItem>{formatCentsToReal(invoice.amount)}</RowItem>
                <RowItem>{getPaymentMethodText(invoice.paymentMethod)}</RowItem>
                <RowItem>
                  {invoice.installments ? invoice.installments : '1'}x
                </RowItem>
                <RowItem>
                  {dayjs(invoice.createdAt).format(dateTypes.dateBR)}
                </RowItem>
                <RowItem>
                  <StatusBadge
                    text={getInvoiceStatusText(invoice.status)}
                    color={InvoiceStatusColors[invoice.status.toUpperCase()]}
                  />
                </RowItem>
              </ul>
            ))}
          </main>
          <footer>
            {hasNextPage && !isLastPage && (
              <Button
                type="button"
                variant="outlined"
                text={isLoading || isFetching ? 'Carregando...' : 'Ver mais'}
                width="120px"
                onClick={() => fetchNextPage()}
              />
            )}
          </footer>
        </Table>
      )}
    </BoxContainer>
  )
}

export default PaymentTable
